// extracted by mini-css-extract-plugin
export default {"page":"OrdersPage_page__zzwu","board":"OrdersPage_board_jc2fe","footer":"OrdersPage_footer_idGTD"};